import React from 'react'
import { switchLanguageAndReload } from "../../../commons/Utils/LanguageSwitcher";

export default function HeaderMenuLoggedOut ({ locale }) {

  function handleSwitchLanguage(event, langCode) {
    event.preventDefault();
    switchLanguageAndReload(langCode);
  }

  return (
    <div className="header-login">
      <a className="header-login__subscribe js-ahoy button-primary button-s"
        data-ahoy-props='{"action" : "subscribe", "feature" : "subscribe button", "referrer": "#{document.referrer}", "page": "#{location.href}"}'
        data-ahoy-click="true"
        data-ahoy-title="SUBSCRIPTION"
        href="/packages"
      >
        {locale.subscribe}
      </a>
      <a className="header-login__button button-s button-secondary"
        href="/users/login"
      >
        {locale.login_button}
      </a>
      <div className="header-login__options header-login__options--logged-out">
        <div className="header-login__more">
          <div className="bento"/>
        </div>
        <input className="hidden" type="checkbox" id="options"/>
        <div className="header-login__menu js-header-menu"
          data-ahoy-impression="true"
          data-ahoy-title="ONBOARDING"
          data-ahoy-props='{"action":"impression", "feature": "more menu"}'
          data-use-bounding-client-rect="true"
        >
          <div className="option">
            <input className="hidden" type="checkbox" id="option-premier" />
            <input className="hidden" type="checkbox" id="option-library" />
            <input className="hidden" type="checkbox" id="option-setting" />
            <input className="hidden" type="checkbox" id="option-lang" />
            <ul className="option__side" data-input-from="option-premier">
              <li>
                <label className="header-login__more" htmlFor="option-premier">
                  <div className="option__title item back">
                    {locale.profile_menu.subscriptions_and_purchases}
                  </div>
                </label>
              </li>
              <hr />
              <li>
                <a className="option__link" href="/packages">
                  {locale.profile_menu.subscribe_premier}
                </a>
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/dashboard/transaction/histories"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "paket aktif", "feature": "locked menu"}'
                >
                  {locale.profile_menu.active_packages}
                </a>
              </li>
              <li>
                <a className="option__link js-link__promo-voucher" href="/promo">
                  {locale.profile_menu.promo_voucher}
                </a>
              </li>
              <li>
                <a className="option__link" href="/redeem">
                  {locale.profile_menu.redeem_voucher}
                </a>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-library">
              <li>
                <label className="header-login__more" htmlFor="option-library">
                  <div className="option__title item back">
                    {locale.profile_menu.my_library}
                  </div>
                </label>
              </li>
              <li>
                <hr />
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                href="/users/login?onboarding_source=locked+menu&user_return_to=/my-list"
                data-ahoy-click="true"
                data-ahoy-title="ONBOARDING"
                data-ahoy-props='{"action":"click", "item": "daftarku", "feature": "locked menu"}'>
                {locale.profile_menu.my_list}
                </a>
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/purchased"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "dibeli", "feature": "locked menu"}'
                >
                  {locale.profile_menu.purchased}
                </a>
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/dashboard/feeds"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "mengikuti", "feature": "locked menu"}'>
                  {locale.following}
                </a>
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/dashboard/histories"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "riwayat tontonan", "feature": "locked menu"}'>
                  {locale.profile_menu.watch_history}
                </a>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-setting">
              <li>
                <label className="header-login__more" htmlFor="option-setting">
                  <div className="option__title item back">
                    {locale.profile_menu.help_and_others}
                  </div>
                </label>
              </li>
              <li>
                <hr />
              </li>
              <li>
                <a className="option__link" href="https://support.vidio.com">
                  {locale.login_menu.help}
                </a>
              </li>
              <li>
                <a className="option__link" href="/pages/terms-and-conditions">
                  {locale.login_menu.terms}
                </a>
              </li>
              <li className="option__link" href="https://careers.vidio.com" rel="noopener">
                {locale.login_menu.careers}
              </li>
              <li>
                <hr />
              </li>
              <li>
                <label className="header-login__more" htmlFor="option-lang">
                  <div className="item forward">
                    {locale.login_menu.language}
                  </div>
                </label>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-lang">
              <li>
                <label className="header-login__more" htmlFor="option-lang">
                  <div className="option__title item back">
                    {locale.login_menu.language}
                  </div>
                </label>
              </li>
              <li><hr /></li>
              <li>
                <a onClick={(e) => {handleSwitchLanguage(e, "id")}} className="option__link" href="#">
                  Indonesia
                </a>
              </li>
              <li>
                <a onClick={(e) => {handleSwitchLanguage(e, "en")}} className="option__link" href="#">
                  English
                </a>
              </li>
            </ul>
            <ul className="option__base">
              <li>
                <div className="option__kids-mode-wrapper">
                  <div className="option__kids-mode-icon"/>
                  <div className="option__kids-mode-title">
                    {locale.login_menu.kids_mode_title}
                  </div>
                  <label className="option__kids-mode-toggle">
                    <input type='checkbox' id='kids-mode' />
                    <span className="option__kids-mode-slider option__kids-mode-toggle-button" />
                  </label>
                </div>
              </li>
              <li><hr /></li>
              <li>
                <label className="header-login__more" htmlFor="option-premier">
                  <div className="item forward">
                    {locale.profile_menu.subscriptions_and_purchases}
                  </div>
                </label>
              </li>
              <li>
                <label className="header-login__more" htmlFor="option-library">
                  <div className="item forward">
                    {locale.profile_menu.my_library}
                  </div>
                </label>
              </li>
              <li><hr /></li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/tv"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "hubungkan ke tv", "feature": "locked menu"}'>
                  {locale.profile_menu.login_tv}
                </a>
              </li>
              <li>
                <a className="option__link locked js-ahoy"
                  href="/users/login?onboarding_source=locked+menu&user_return_to=/referral"
                  data-ahoy-click="true"
                  data-ahoy-title="ONBOARDING"
                  data-ahoy-props='{"action":"click", "item": "undang teman", "feature": "locked menu"}'>
                  {locale.profile_menu.referral_voucher}
                </a>
              </li>
              <li>
                <label className="header-login__more" htmlFor="option-setting">
                  <div className="item forward">
                    {locale.profile_menu.help_and_others}
                  </div>
                </label>
              </li>
              <li>
                <a className="option__link" href="https://about.vidio.com">
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )

}
